import RegionsApi from '../RegionsApi';
import * as types from './ActionTypes';
import IRegion from '../types/Region';

export function loadRegionsSuccess(results: IRegion[]) {
    return { type: types.LOAD_REGIONS_SUCCESS, result: results };
}

export function createRegionSuccess(result: IRegion) {
    return { type: types.CREATE_REGION_SUCCESS, result };
}

export function editRegionSuccess(result: IRegion) {
    return { type: types.EDIT_REGION_SUCCESS, result };
}

export function updateRegionSuccess(result: IRegion) {
    return { type: types.UPDATE_REGION_SUCCESS, result };
}

export function deleteRegionSuccess(result: number) {
    return { type: types.DELETE_REGION_SUCCESS, result: { id: result } };
}

export function loadRegions() {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        RegionsApi.getRegions().then((result: IRegion[]) => {
            dispatch(loadRegionsSuccess(result));
        });
}

export function createRegion(region: IRegion) {
    return (dispatch: (result: any) => void) =>
        RegionsApi.createRegion(region).then((result: any) => {
            dispatch(createRegionSuccess(result));
        });
}

export function editRegion(id: number) {
    return (dispatch: (result: any) => void) =>
        RegionsApi.editRegion(id).then((result: any) => {
            dispatch(editRegionSuccess(result));
        });
}

export function updateRegion(region: IRegion) {
    return (dispatch: (result: any) => void) =>
        RegionsApi.updateRegion(region).then((result: any) => {
            dispatch(updateRegionSuccess(result));
        });
}

export function deleteRegion(id: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        RegionsApi.deleteRegion(id).then(() => {
            dispatch(deleteRegionSuccess(id));
        });
}
